module.exports = __webpack_public_path__ + "eec4ef5da578ba357e941aea4bd0865a.mp3";


//////////////////
// WEBPACK FOOTER
// ./sounds/woman.mp3
// module id = 823
// module chunks = 0